import styled from 'styled-components'

export const StyledCallCenterHandler = styled.a`
  border-radius: ${props => props.theme.radius.normal};
  background-color: ${props => props.theme.colors.secondary[25]};
  padding: ${props => props.theme.spacing.medium};
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: ${props => props.theme.colors.black[500]};
  transition: background-color 0.16s ease-in-out;
  width: 48%;

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    width: auto;
  }

  &:hover {
    background-color: ${props => props.theme.colors.secondary[50]};
  }

  &:active {
    background-color: ${props => props.theme.colors.black[200]};
  }
`

export const CallCenterHandlerContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${props => props.theme.spacing.medium};
`

export const IconWrapper = styled.div`
  background-color: ${props => props.theme.colors.success[100]};
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.theme.radius.xxlarge};
`
